/**
 * 推广合伙人：关系来源（relation_type）通用处理
 * 适用接口：/api/center/inviteList、/api/center/rechargeList、/api/center/upgradeList
 *
 * 1 = 自己邀请（原有拉新逻辑）
 * 2 = 子账号（合伙人自己添加的账号）
 * 3 = 子账号邀请（走合伙人分佣 type 38/39 的那类）
 */

export const RELATION_OPTIONS = [
  { value: '', label: '全部' },
  { value: 1, label: '自己邀请' },
  { value: 2, label: '子账号' },
  { value: 3, label: '子账号邀请' }
]

const RELATION_MAP = {
  1: { label: '自己邀请', type: 'info' },
  2: { label: '子账号', type: 'warning' },
  3: { label: '子账号邀请', type: 'success' }
}

// 来源文案：优先用后端 relation_type_txt，缺失时用本地映射兜底
export function getRelationLabel(row) {
  if (!row) return ''
  const item = RELATION_MAP[row.relation_type]
  if (row.relation_type_txt) return row.relation_type_txt
  return (item && item.label) || '-'
}

// 来源标签配色
export function getRelationTagType(row) {
  const item = RELATION_MAP[row && row.relation_type]
  return (item && item.type) || 'info'
}

// 归属子账号文案（relation_type=3 时 parent_sub 有值）
export function getParentSubText(row) {
  const sub = row && row.parent_sub
  if (!sub) return '-'
  return sub.nick || (sub.uid ? String(sub.uid) : '-')
}

// 将 relation_type 追加到请求参数；空值不传（保持改造前行为）
export function withRelationType(params, relationType) {
  if (relationType !== '' && relationType !== null && relationType !== undefined) {
    params.relation_type = relationType
  }
  return params
}

// 接口成功判定：兼容 code 0 / 200
export function isSuccess(res) {
  return !!res && (res.code === 0 || res.code === 200)
}
